<template>
    <div class="tyn-root">
        <Header></Header>

        <div class="tyn-content tyn-contact  has-aside-base">
            <Historico :nmComponente="'Artefato'" :reload="reload" :seleciona="seleciona" :novo="novo" :id="idArtefato"></Historico>

            <div class="tyn-main tyn-content-inner" id="tynMain">
                <ul class="tyn-list-inline d-md-none translate-middle-x position-absolute start-50 z-1">
                    <li>
                        <button class="btn btn-icon btn-pill btn-white js-toggle-main" @click="fechar">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg><!-- x-lg -->
                        </button>
                    </li>
                </ul>
                <div class="tyn-chat-body m-4 rounded-3" data-simplebar>
                    <div class="container px-0">
                        <template v-if="idArtefato == 0">
                            <div class="tyn-qa tyn-qa-bubbly">
                                <!-- NOVO -->

                                <template v-if="flRealizaArtefato">
                                    <!-- nao pode realizar novo -->
                                    <template v-if="!(utilizacoes && utilizacoes.permiteRealizarArtefatos) && flVerificouUtilizacoes">
                                        <div class="tyn-qa-item">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p>
                                                    Desculpe, parece que você atingiu seu limite de Artefatos do contrato.
                                                    Entre em contato com um dos nossos consultores.
                                                </p>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- LEGISLACAO -->
                                    <template>
                                        <div class="tyn-qa-item">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p><span class="fw-bold">Escolha a legislação:</span> (Baseado em qual lei deseja a resposta). </p>
                                                <div class="d-flex align-items-center mb-1 ps-3" v-for="(item,index) in lstLegislacao" :key="index">
                                                    <input type="radio" :id="'legislacao-'+item.idLegislacaoModeloArtefato" name="idLegislacaoModeloArtefato" v-model="idLegislacaoModeloArtefato" :value="item.idLegislacaoModeloArtefato" />
                                                    <label class="ps-2" :for="'legislacao-'+item.idLegislacaoModeloArtefato">
                                                        {{item.dsNome}} {{(item.dsLegislacao && item.dsLegislacao != ""? "- "+item.dsLegislacao : "")}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 0">
                                            <div class="col text-end">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(0)">Próximo</button>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- MODELO -->
                                    <template v-if="etapa > 0">
                                        <div class="tyn-qa-item" ref="etapa1">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p><span class="fw-bold">Escolha seus Artefatos:</span> Selecione artefatos específicos que deseja produzir.</p>
                                                <template v-if="lstModelos.length > 0">
                                                    <template v-if="flTemModelos">
                                                        <div v-for="(item,index) in lstModelos" :key="index">
                                                            <template v-if="item.lstModeloArtefato.length > 0">
                                                                <h5>• {{item.modeloArtefatoFase.dsNome}}</h5>
                                                                <div v-for="(item2,index2) in item.lstModeloArtefato" class="d-flex align-items-center mb-1 ps-3" :key="index2">
                                                                    <input type="radio" :id="'modelo-'+item2.modeloArtefato.idModeloArtefato" name="artefatos1" v-model="idModelo" :value="item2.modeloArtefato.idModeloArtefato" />
                                                                    <label class="ps-2" :for="'modelo-'+item2.modeloArtefato.idModeloArtefato"
                                                                           :data-bs-toggle="(item2.modeloArtefato.dsModelo != null?'popoverModelo':'')" data-bs-placement="top" title="Detalhes" :data-bs-content="getDataBs(item2)">{{item2.modeloArtefato.nmModelo}}</label>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <span>Nenhum modelo encontrado para a legislação selecionada.</span>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <span>Nenhum modelo encontrado para a legislação selecionada.</span>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 1">
                                            <div class="col text-end">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(1)">Próximo</button>
                                            </div>
                                        </div>
                                    </template>


                                    <!-- ARQUIVO -->
                                    <template v-if="etapa > 1">
                                        <div class="tyn-qa-item" ref="etapa2">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p class="fw-bold mb-2">
                                                    Gostaria de me ajudar a produzir o esboço?
                                                </p>

                                                <template v-if="idModelo">
                                                    <p>{{getDetalhesModelo(idModelo)}}</p>
                                                </template>

                                                <p class="mb-0">Envie aqui as informações que você já possui sobre a contratação </p>
                                                <p>(Exemplo: descrição do objeto ou serviço que deseja licitar; um processo anterior já realizado; pesquisa de preços; etc)</p>

                                                <AvisoUploadDocumentos />

                                                <ImputUploadS3 :reset="resetUpload" :labelText="'Selecionar Arquivo'" @onSave="setUploadFile" @onDelete="deleteUploadFile" :destino="'Artefato'" :id="'input_file_artefato'" :whoFiles="'.pdf,.docx'"></ImputUploadS3>

                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 2">
                                            <div class="col text-end" v-if="utilizacoes && utilizacoes.permiteRealizarArtefatos">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(2)">Próximo</button>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- NORMATIVA -->
                                    <template v-if="false && etapa > 2 && lstNormas.length > 0">
                                        <div class="tyn-qa-item" ref="etapa3">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p class="fw-bold mb-2">
                                                    Deseja utilizar alguma normativa:
                                                </p>
                                                <div class="d-flex align-items-center mb-1 ps-3">
                                                    <input type="radio" :id="'normaArtefato'" name="normaArtefato" :value="null" v-model="idNorma" :disabled="disabled" />
                                                    <label class="ps-2" :for="'normaArtefato'">
                                                        Não utilizar normativa
                                                    </label>
                                                </div>
                                                <div class="d-flex align-items-center mb-1 ps-3" v-for="(item,index) in lstNormas" v-bind:key="index">
                                                    <input type="radio" :id="'normaArtefato'+ index" name="normaArtefato" :value="item.idNorma" v-model="idNorma" :disabled="disabled" />
                                                    <label class="ps-2" :for="'normaArtefato'+index">
                                                        {{item.dsNome}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 3">
                                            <div class="col text-end" v-if="utilizacoes && utilizacoes.permiteRealizarArtefatos">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(3)">Enviar</button>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                                <template v-else-if="flVerificouRealizar">
                                    <div class="tyn-qa-item">
                                        <div class="tyn-qa-avatar">
                                            <div class="tyn-qa-avatar-wrap">
                                                <div class="tyn-media tyn-size-md" style="background: transparent">
                                                    <img src="assets/images/sollai/avatar.png" alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tyn-qa-message tyn-text-block bg-response">
                                            <p>
                                                Aguarde a conclusão do artefato atual antes de realizar um novo.
                                            </p>
                                        </div>
                                    </div>
                                </template>
                            </div>

                        </template>
                        <template v-else>
                            <!-- RESULTADO -->
                            <div class="tyn-qa tyn-qa-bubbly">
                                <div class="tyn-qa-item" v-if="artefato">
                                    <div class="tyn-qa-avatar">
                                        <div class="tyn-qa-avatar-wrap">
                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                <template v-if="user.usuarioApi">
                                                    <img v-if="user.usuarioApi.urlImgFoto" :src="user.usuarioApi.urlImgFoto" alt="" />
                                                    <img v-else src="assets/images/avatar/3.jpg" alt="">
                                                </template>
                                                <template v-else>
                                                    <img src="assets/images/avatar/3.jpg" alt="">
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tyn-qa-message tyn-text-block bg-response">
                                        <template v-if="artefato.usuario">
                                            <p class="mb-0" v-if="user.usuario.dsLogin != artefato.usuario.dsLogin">
                                                <strong>Usuário: </strong>{{artefato.usuario.nmUsuario}}
                                            </p>
                                        </template>
                                        
                                        <p class="mb-0" v-if="artefato.modelo">
                                            <strong>Modelo: </strong> <a class="c-pointer" href="javascript:void(0)" @click="download(artefato.modelo.urlArquivo,true)">{{artefato.nmModelo}}</a>
                                        </p>
                                        <p class="mb-0" v-if="artefato.urlArquivo">
                                            <strong>Fonte de dados: </strong> <a class="c-pointer" href="javascript:void(0)" @click="download(artefato.urlArquivo)">{{getNomeArquivo(artefato.urlArquivo)}}</a>
                                        </p>
                                        <p class="mb-0" v-if="legislacao">
                                            <strong>Legislação: </strong>
                                            <a href="javascript:void(0)" @click="openReferencia(legislacao.tpConteudo, legislacao.idConteudo)">
                                                {{legislacao.dsNome}}
                                            </a>
                                        </p>
                                        <p class="mb-0" v-if="norma">
                                            <strong>Normativa: </strong>
                                            <a href="javascript:void(0)" @click="downloadNormativa(norma.urlArquivo, norma.dsNome)">
                                                {{norma.dsNome}}
                                            </a>
                                        </p>
                                        <p class="mb-0">
                                            <strong>Data da solicitação: </strong>{{artefato.dtInclusao}}
                                        </p>
                                    </div>
                                </div>
                                <div class="tyn-qa-item">
                                    <div class="tyn-qa-avatar">
                                        <div class="tyn-qa-avatar-wrap">
                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                <img src="assets/images/sollai/avatar.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tyn-qa-message tyn-text-block bg-response">
                                        <template v-if="statusArtefato == 'Processando' || statusArtefato == 'Iniciada'">
                                            <p class="fw-bold mb-2">
                                                {{mensagemProcessando}}
                                            </p>
                                            <p class="mb-2">
                                                Por favor, aguarde um momento enquanto eu processo seu artefato. Obrigado pela sua paciência e compreensão.
                                            </p>
                                            <div class="progress px-0 d-none">
                                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: '20%'}"></div>
                                            </div>

                                        </template>
                                        <template v-if="statusArtefato == 'Cancelada'">
                                            <span class="text-danger fs-1">
                                                <i class="fas fa-exclamation-triangle text-danger fs-1"></i>
                                            </span>
                                            <p class="fw-bold mb-2">
                                                Erro ao processar o artefato
                                            </p>
                                            <p class="mb-2">
                                                {{msgErro}}
                                            </p>
                                        </template>
                                        <template v-if="statusArtefato == 'Finalizada'">
                                            <template v-if="artefato">
                                                <p class="mb-20">Seu documento esta pronto!</p>
                                                <p>Faça o download do arquivo.</p>

                                                <div class="row justify-content-end" v-if="artefato.documento">
                                                    <div class="col text-end">
                                                        <button class="btn btn-outline-primary" @click="download(artefato.documento.urlArquivo,true)" v-if="artefato.documento.urlArquivo">
                                                            <span class="ms-0">Fazer Download</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mt-3">
                                <button class="btn btn-outline-primary" @click="novo">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                    </svg> Criar novo artefato
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
                
            </div>
        </div>

        <!-- MODAIS HEADER -->
        <Modais></Modais>

        <ModalDetalhes :dados="modalDetalhes" :showModal="showModalDetalhes"></ModalDetalhes>
    </div>
</template>
<script>
    import Header from '@/components/Header'
    import Historico from '@/components/Historico'
    import Modais from '@/components/Modais'
    import ModalDetalhes from '@/components/ModalDetalhes'
    import ImputUploadS3 from '@/components/Input_Upload_s3'
    import AvisoUploadDocumentos from '@/components/AvisoUploadDocumentos'

    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'Artefato',
        components: { Header, Historico, ModalDetalhes, ImputUploadS3, AvisoUploadDocumentos, Modais },
        computed: {
            user() {
                return this.$store.state.user
            },
            hubConection() {
                return this.$store.state.hubConection
            },
            lstNormas() {
                return this.$store.state.lstNormas
            },
        },
        data: function () {
            return {
                reload: false,

                idArtefato: 0,
                lstModelos: [],

                idModelo: null,
                idNorma: null,
                urlArquivoS3: null,
                etapa: 0,
                msgErro: null,
                flReprocessar: false,
                disabled: false,
                statusArtefato: null,
                artefato: null,

                dropzoneOptions: {
                    url: urlApi + '/Documento/EnviarDocumento',
                    maxFilesize: 0.5,
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    headers: { "My-Awesome-Header": "header value" }
                },

                flRealizaArtefato: false,
                utilizacoes: null,
                flVerificouUtilizacoes: false,
                mensagemProcessando: "Processando artefato...",
                flVerificouRealizar: false,

                lstLegislacao: [],
                idLegislacaoModeloArtefato: null,

                flTemModelos: null,
                legislacao: null,
                norma: null,

                modalDetalhes: {
                    cdConteudo: null,
                    idItemPesquisa: null,
                    dsReferencia: null,
                },

                showModalDetalhes: false,
                resetUpload: false,
            }
        },

        methods: {
            fechar() {
                document.getElementById('tynMain').classList.toggle('main-shown')
            },

            seleciona(id, tipo) {
                if (tipo == 2) {
                    this.idArtefato = id;
                    this.load();
                }
            },

            novo() {
                this.idArtefato = 0;
                this.etapa = 0;
                this.idModelo = null;
                this.idNorma = null;
                this.urlArquivoS3 = null;
                this.resetUpload = !this.resetUpload;
                this.flReprocessar = false;

                this.load();
            },

            load() {
                if (this.idArtefato != 0) {
                    this.carregaArtefato();
                }

                this.carregaLegislacoes();
                this.verificaRealizaArtefato();
                this.carregaUtilizacoes();
            },

            carregaModelos() {
                let $this = this;
                $this.lstModelos = [];
                axios.get(`${urlApi}/Modelo/GetFases`, { showLoading: false, params: { idLegislacaoModeloArtefato: $this.idLegislacaoModeloArtefato } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstModelos = res.data.data.rows;

                            let flTemModelos = false;
                            for (let i = 0; i < $this.lstModelos.length; i++) {
                                if ($this.lstModelos[i].lstModeloArtefato.length > 0) {
                                    flTemModelos = true;
                                }
                            }

                            $this.flTemModelos = flTemModelos;
                            $this.montaPopover();
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            carregaLegislacoes() {
                let $this = this;
                $this.lstLegislacao = [];
                axios.get(`${urlApi}/Legislacao/GetLegislacaoArtefato`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstLegislacao = res.data.data;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            InitSignalR() {
                try {
                    let $this = this;
                    //var token = $this.user.accessToken;
                    //var connection = new window.signalR.HubConnectionBuilder().withUrl(`${urlSignal}notificacaohub?p_dsLogin=` + $this.user.usuario.dsLogin, { accessTokenFactory: () => token }).build();

                    $this.hubConection.on("RecebeNotificacaoArtefato", function (idArtefato, status, dtAtualizacao) {
                        if ($this.idArtefato == idArtefato) {
                            $this.load();
                        } else {
                            avisoToast('Status do artefato atualizado para ' + status + ' - ' + moment(dtAtualizacao).format('DD/MM/YYYY [às] HH:mm'));
                        }
                    });

                    $this.hubConection.on("AtualizaRealizarArtefato", function (flRealizaArtefato) {
                        $this.flRealizaArtefato = flRealizaArtefato == "Sim" || flRealizaArtefato == "true" ? true : false;
                    });

                    $this.hubConection.on("AtualizaStatusArtefato", function (idArtefato, status,) {
                        $this.mensagemProcessando = status;
                    });

                    //$this.hubConection.start().then(function () {
                    //    console.log('Connetado!');
                    //}).catch(function (err) {
                    //    return console.error('Erro: ', err.toString());
                    //});

                    ////$this.hubConection.disconnected(function () {
                    ////    setTimeout(function () {
                    ////        console.log('Tentando Reconectar!');
                    ////        $this.hubConection.hub.start();
                    ////    }, 5000);
                    ////});
                    //$this.hubConection.onclose(async () => {
                    //    setTimeout(function () {
                    //        console.log('Tentando Reconectar!');
                    //        $this.hubConection.hub.start();
                    //    }, 5000);
                    //});
                }
                catch (ex) {
                    console.log(ex);
                }
            },

            proximo(p_etapa) {
                switch (p_etapa) {
                    case 0:
                        if (this.idLegislacaoModeloArtefato) {
                            this.carregaModelos();
                            this.etapa = this.etapa + 1;

                            this.$nextTick(function () {
                                const el = this.$refs.etapa1;

                                if (el) {
                                    // Use el.scrollIntoView() to instantly scroll to the element
                                    el.scrollIntoView({ behavior: 'smooth' });
                                }
                            });
                        } else {
                            avisoToast("Selecione uma legislação", "warning");
                        }

                        break;
                    case 1:
                        if (this.idModelo) {

                            this.etapa = this.etapa + 1;

                            this.$nextTick(function () {
                                const el = this.$refs.etapa2;

                                if (el) {
                                    // Use el.scrollIntoView() to instantly scroll to the element
                                    el.scrollIntoView({ behavior: 'smooth' });
                                }
                            });
                        } else {
                            avisoToast("Selecione um modelo", "warning");
                        }
                        break;


                    case 2:
                        if (this.idModelo) {
                            if (this.urlArquivoS3 != null && this.urlArquivoS3 != "") {
                                if (this.utilizacoes && this.utilizacoes.permiteRealizarArtefatos) {
                                    //this.etapa = 3;

                                    this.enviarArtefato();
                                    //if (this.lstNormas.length == 0) {
                                    //    this.etapa = 4;
                                    //    this.enviarArtefato();
                                    //}

                                } else {
                                    avisoToast("Desculpe, parece que você atingiu seu limite de Artefatos do contrato. Entre em contato com um dos nossos consultores.", "warning");
                                }
                            } else {
                            avisoToast("Selecione um arquivo", "warning");
                            }
                        } else {
                            avisoToast("Selecione um modelo", "warning");
                        }
                        break;

                    //case 3:
                    //    if (this.utilizacoes && this.utilizacoes.permiteRealizarArtefatos) {
                    //        this.etapa = 4;
                    //        this.enviarArtefato();

                    //    } else {
                    //        avisoToast("Desculpe, parece que você atingiu seu limite de Artefatos do contrato. Entre em contato com um dos nossos consultores.", "warning");
                    //    }
                    //    break;

                    default:
                        break;
                }
            },

            enviarArtefato() {
                let $this = this;
                $this.statusArtefato = 'Processando';
                $this.disabled = true;

                const formData = new FormData();

                //const inputFile = document.querySelector("#myfile");
                //if (inputFile != null) {
                //    formData.append("form.file", inputFile.files[0]);
                //}
                formData.append("form.idModelo", $this.idModelo);
                formData.append("form.urlArquivoS3", $this.urlArquivoS3);

                if ($this.idNorma != null) {
                    formData.append("form.idNorma", $this.idNorma);
                }

                axios.post(`${urlApi}/Artefato/Post`, formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, } })
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Artefato registrado com sucesso, acompanhe a situação no campo status da listagem.");

                            $this.reload = !$this.reload;
                            $this.idArtefato = parseInt(res.data.data);
                            $this.load();

                        } else {
                            $this.flReprocessar = true;
                            avisoErro("Não foi possível enviar o artefato.");
                        }
                    })
                    .catch(res => {
                        $this.flReprocessar = true;
                        $this.statusArtefato = 'Cancelada';
                        $this.msgErro = 'Não foi possível enviar o artefato.';
                        if (res.response.data?.errors) {
                            $this.msgErro = 'Não foi possível enviar o artefato.' + " - " + res.response.data.errors[0];
                            avisoErro('Não foi possível enviar o artefato.' + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível enviar o artefato.");
                        }
                    });
            },

            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/Artefato/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        $this.flVerificouUtilizacoes = true;
                        if (res.data.success) {
                            $this.utilizacoes = res.data.data;
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de artefatos.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de artefatos.");
                        }
                        $this.loading.hide();
                    });
            },

            verificaRealizaArtefato() {
                let $this = this;
                axios.get(`${urlApi}/Artefato/VerificaRealizarArtefato`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.flRealizaArtefato = res.data.data;
                            $this.flVerificouRealizar = true;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            carregaArtefato() {
                let $this = this;
                axios.get(`${urlApi}/Artefato/Get/${$this.idArtefato}`)
                    .then(res => {
                        $this.artefato = null;
                        if (res.data.success) {
                            var result = res.data.data;

                            var status = '';
                            if (result.lstArtefatoMovimento.length > 0) {
                                status = result.lstArtefatoMovimento[result.lstArtefatoMovimento.length - 1].dsMovimento;
                                $this.statusArtefato = status;
                            }

                            $this.artefato = {
                                idArtefato: result.artefato.idArtefato,
                                dsLogin: result.artefato.dsLogin,
                                dsNome: result.artefato.dsNome,
                                dtInclusao: moment(result.artefato.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                nmModelo: result.modeloArtefato.nmModelo,
                                status: status,
                                usuario: result.usuario,
                                modelo: result.modeloArtefato,
                                documento: result.documento,
                                dsResposta: result.artefato.dsResposta,
                                urlArquivo: result.artefato.urlArquivo,
                                nmLegislacao: (result.modeloArtefato.idLegislacaoModeloArtefato == 1 ? "14.133" : "13.303"),
                                idNorma: result.artefato.idNorma,
                            };

                            if (result.modeloArtefato.idLegislacaoModeloArtefato) {
                                $this.getLegislacao(result.modeloArtefato.idLegislacaoModeloArtefato == 1 ? 1 : 3);
                            }

                            if ($this.artefato.idNorma) {
                                $this.getNorma($this.artefato.idNorma);
                            } else {
                                $this.norma = null;
                            }
                        } else {
                            avisoErro("Não foi possível carregar o artefato.");
                        }

                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("erro");
                        }
                        $this.loading.hide();
                    });
            },

            getLegislacao(idLegislacao) {
                let $this = this;
                axios.get(`${urlApi}/Legislacao/Get/${idLegislacao}`)
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.legislacao = result;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            downloadArtefato(idArtefatoMovimento, urlArquivo) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1].slice(10);
                }
                axios({
                    url: `${urlApi}/Artefato/DownloadDocumento/${idArtefatoMovimento}`, //your url
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        // create file link in browser's memory
                        const href = URL.createObjectURL(response.data);

                        // create "a" HTML element with href to file & click
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', nmArquivo); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        // clean up "a" element & remove ObjectURL
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            download(urlArquivo, flNome = false) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    if (flNome) {
                        nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    } else {
                        nmArquivo = nomeArquivo[nomeArquivo.length - 1].slice(7);
                    }
                }

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },

            getNomeArquivo(urlArquivo) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1].slice(7)
                    return nmArquivo;
                } else {
                    return "daods";
                }
            },

            openReferencia(cdConteudo, idItemPesquisa, dsReferencia) {
                this.modalDetalhes = {
                    cdConteudo: cdConteudo,
                    idItemPesquisa: idItemPesquisa,
                    dsReferencia: dsReferencia,
                };
                this.showModalDetalhes = !this.showModalDetalhes;
            },

            getDataBs(item) {
                return ` <span class="mb-0"> ${(item.modeloArtefato.dsModelo != null ? item.modeloArtefato.dsModelo : item.modeloArtefato.nmModelo)}</span>`;
            },

            montaPopover() {
                var popovers = document.querySelectorAll(".popover");
                // Itera sobre cada elemento e remove-o
                popovers.forEach(function (popover) {
                    popover.remove();
                });
                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popoverModelo"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    placement: "top",
                                    customClass: "custom-popover" 
                                });
                            });
                    }
                });
            },

            getNorma(idNorma) {
                let $this = this;
                axios.get(`${urlApi}/Norma/Get/${idNorma}`)
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.norma = result;
                            if ($this.norma.nmNorma) {
                                $this.norma.dsNome = $this.norma.nmNorma;
                            } else if ($this.norma.nmArquivo == null || $this.norma.nmArquivo == "") {
                                var nomeArquivo = $this.norma.urlArquivo.split('/');
                                if (nomeArquivo.length > 0) {
                                    //item.dsNome = nomeArquivo[nomeArquivo.length - 1].slice(7);
                                    $this.norma.dsNome = nomeArquivo[nomeArquivo.length - 1];
                                }
                            } else {
                                $this.norma.dsNome = $this.norma.nmArquivo;
                            }
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            downloadNormativa(urlArquivo, dsNome) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    nmArquivo = dsNome + "." + nmArquivo.split(".")[1];
                }

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },

            setUploadFile(urlArquivoS3) {
                this.urlArquivoS3 = urlArquivoS3.key;
            },

            deleteUploadFile(hash) {
                this.files = this.files.filter(function (obj) { return obj.hash !== hash });
            },

            getDetalhesModelo(idModeloArtefato) {
                for (const etapa of this.lstModelos) {
                    const modelo = etapa.lstModeloArtefato.find(x => x.modeloArtefato.idModeloArtefato == idModeloArtefato)
                    if (modelo && modelo.modeloArtefato) {
                        return modelo.modeloArtefato.nmModelo + (modelo.modeloArtefato.dsModelo != null ? " - " + modelo.modeloArtefato.dsModelo : "");
                    }
                }
                return "";
            },
        },
        mounted: function () {
            this.load();

            if (this.$route.query.idModelo != undefined && this.$route.query.idLegislacao != undefined) {
                this.idLegislacaoModeloArtefato = this.$route.query.idLegislacao;
                this.etapa = 2;

                let $this = this;
                $this.$nextTick(function () {
                    $this.idModelo = $this.$route.query.idModelo;

                    setTimeout(function () {
                        const el = $this.$refs.etapa2;
                        if (el) {
                            // Use el.scrollIntoView() to instantly scroll to the element
                            el.scrollIntoView({ behavior: 'smooth' });
                        }
                    },300)
                    
                })
                
            }

            // signalR
            if (this.hubConection != undefined) {
                // signalR
                this.InitSignalR();
            }
        },
        watch: {
            idLegislacaoModeloArtefato: function () {
                this.idModelo = null;
                this.carregaModelos();
            },            
        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .tyn-qa-bubbly .tyn-qa-item:nth-child(even) .tyn-qa-message.bg-question, .tyn-qa-bubbly .tyn-qa-item:nth-child(odd) .tyn-qa-message.bg-question {
        background: var(--qa-bg-human);
    }

    .tyn-qa-bubbly .tyn-qa-item:nth-child(odd) .tyn-qa-message.bg-response, .tyn-qa-bubbly .tyn-qa-item:nth-child(even) .tyn-qa-message.bg-response {
        background: var(--qa-bg);
    }

    a {
        color: var(--bs-body-color);
    }

        a:hover, li:hover {
            text-decoration: underline;
            color: var(--bs-body-color);
        }

    .referencias {
        padding-left: 30px;
    }

        .referencias li {
            font-size: 14px;
        }

    .resposta {
        text-align: justify;
    }

    /* ========================================
       ESTILOS MODERNOS - ARTEFATO
       ======================================== */
    
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes pulse {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.02);
        }
    }

    @keyframes shimmer {
        0% {
            background-position: -1000px 0;
        }
        100% {
            background-position: 1000px 0;
        }
    }

    /* Melhorias nas respostas da IA */
    .tyn-qa-message {
        transition: all 0.3s ease;
        
        &.bg-question {
            background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
            border-left: 4px solid #1f7bff;
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.15);
        }

        &.bg-response {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
            border-left: 4px solid #00d084;
            box-shadow: 0 2px 8px rgba(0, 208, 132, 0.15);
        }
    }

    /* Botões de opções modernos */
    .btn-outline-primary {
        border: 2px solid #1f7bff;
        color: #1f7bff;
        background: transparent;
        border-radius: 12px;
        padding: 0.65rem 1.5rem;
        font-weight: 600;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.1);

        &:hover {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: transparent;
            color: white;
            box-shadow: 0 6px 20px rgba(31, 123, 255, 0.3);
            transform: translateY(-2px);
        }

        &:active {
            transform: translateY(0);
        }
    }

    /* Progress bar moderna */
    .progress {
        height: 8px;
        border-radius: 10px;
        background: rgba(233, 236, 239, 0.5);
        overflow: hidden;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .progress-bar {
        border-radius: 10px;
        background: linear-gradient(90deg, #1f7bff 0%, #00d084 100%);
        background-size: 200% 100%;
        animation: shimmer 2s linear infinite;
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.4);
    }

    /* Animações para mensagens de erro */
    .text-danger {
        animation: pulse 2s ease-in-out infinite;
    }

    /* Melhorias nos radio buttons */
    input[type="radio"] {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: 1.25rem;
        height: 1.25rem;
        border: 2px solid #cbd5e0;
        border-radius: 50%;
        outline: none;
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        background: white;
        flex-shrink: 0;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0);
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: white;
            transition: transform 0.2s ease;
        }

        &:checked {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: #1f7bff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.15);

            &::before {
                transform: translate(-50%, -50%) scale(1);
            }
        }

        &:hover:not(:disabled) {
            border-color: #1f7bff;
            transform: scale(1.1);
        }

        &:focus {
            outline: none;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.15);
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            background: #f1f3f5;
        }
    }

    label {
        cursor: pointer;
        transition: color 0.3s ease;
        user-select: none;

        &:hover {
            color: #1f7bff;
        }
    }

    /* Títulos das seções */
    h5 {
        font-weight: 700;
        color: #2d3748;
        margin-bottom: 0.75rem;
        position: relative;
        padding-left: 1rem;
    }

    /* Links melhorados */
    .c-pointer {
        color: #1f7bff;
        text-decoration: none;
        transition: all 0.3s ease;
        font-weight: 500;

        &:hover {
            color: #00d084;
            text-decoration: underline;
        }
    }

    /* Popover customizado */
    :deep(.custom-popover) {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        border: 2px solid rgba(31, 123, 255, 0.2);

        .popover-header {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            color: white;
            border-radius: 10px 10px 0 0;
            font-weight: 600;
        }

        .popover-body {
            font-size: 0.9rem;
            line-height: 1.6;
        }
    }

    /* Área de upload melhorada */
    :deep(.input-group) {
        border-radius: 12px;
        overflow: hidden;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.15);
        }
    }

    :deep(.form-control) {
        border: 2px solid #e9ecef;
        border-radius: 12px;
        padding: 0.75rem 1rem;
        transition: all 0.3s ease;

        &:focus {
            border-color: #1f7bff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.1);
        }
    }

    :deep(.btn-primary) {
        background: linear-gradient(135deg, #1f7bff 0%, #0056d2 100%);
        border: none;
        border-radius: 10px;
        padding: 0.65rem 1.5rem;
        font-weight: 600;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(31, 123, 255, 0.3);

        &:hover {
            background: linear-gradient(135deg, #0056d2 0%, #003d99 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(31, 123, 255, 0.4);
        }

        &:active {
            transform: translateY(0);
        }
    }

    /* Ícones SVG */
    svg {
        transition: all 0.3s ease;
    }

    .bi-plus-lg {
        font-weight: bold;
    }

    /* Container de mensagens */
    .tyn-chat-body {
        animation: fadeInUp 0.5s ease-out;
    }

    /* Melhorias no container */
    .container {
        transition: all 0.3s ease;
    }

    /* Botão de novo artefato */
    .btn-outline-primary {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;

        svg {
            transition: transform 0.3s ease;
        }

        &:hover svg {
            transform: rotate(90deg) scale(1.1);
        }
    }

    /* Responsivo */
    @media (max-width: 768px) {
        .btn-outline-primary {
            width: 100%;
            justify-content: center;
            padding: 0.75rem 1.5rem;
        }

        h5 {
            font-size: 1rem;
        }

        input[type="radio"] {
            width: 1.1rem;
            height: 1.1rem;
        }
    }

    @media (max-width: 576px) {
        .btn-outline-primary {
            font-size: 0.9rem;
            padding: 0.7rem 1.25rem;
        }

        .tyn-qa-message {
            padding: 1rem;
        }

        h5 {
            font-size: 0.95rem;
            padding-left: 0.75rem;

            &::before {
                width: 3px;
            }
        }
    }

    /* ============================================
       DARK THEME - Artefato
       ============================================ */

    [data-bs-theme="dark"] .tyn-qa-message.bg-question {
        background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%) !important;
        border-left-color: #60a5fa;
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
        color: #e0f2fe;
    }

    [data-bs-theme="dark"] .tyn-qa-message.bg-response {
        background: linear-gradient(135deg, #064e3b 0%, #065f46 100%) !important;
        border-left-color: #34d399;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
        color: #d1fae5;
    }

    [data-bs-theme="dark"] .btn-outline-primary {
        border-color: #3b82f6;
        color: #60a5fa;
        background: transparent;

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
            color: white;
            box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
        }
    }

    [data-bs-theme="dark"] .progress {
        background: #0f1117;
    }

    [data-bs-theme="dark"] .progress-bar {
        background: linear-gradient(90deg, #3b82f6 0%, #10b981 100%);
    }

    [data-bs-theme="dark"] input[type="radio"] {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.2);

        &:checked {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
            border-color: #3b82f6;
        }

        &:disabled {
            background: #1a1d29;
        }
    }

    [data-bs-theme="dark"] label {
        color: #e5e7eb;

        &:hover {
            color: #60a5fa;
        }
    }

    [data-bs-theme="dark"] h5 {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .c-pointer {
        color: #60a5fa;

        &:hover {
            color: #34d399;
        }
    }

    [data-bs-theme="dark"] :deep(.custom-popover) {
        background: #1e2330;
        border-color: rgba(96, 165, 250, 0.3);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);

        .popover-header {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
        }

        .popover-body {
            background: #1e2330;
            color: #e5e7eb;
        }
    }

    [data-bs-theme="dark"] :deep(.input-group) {
        &:hover {
            box-shadow: 0 4px 12px rgba(96, 165, 250, 0.2);
        }
    }

    [data-bs-theme="dark"] :deep(.form-control) {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.12);
        color: #f3f4f6;

        &:focus {
            background: #1a1d29;
            border-color: #60a5fa;
            box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.15);
        }
    }

    [data-bs-theme="dark"] :deep(.btn-primary) {
        background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        }
    }

    [data-bs-theme="dark"] .tyn-qa-message p,
    [data-bs-theme="dark"] .tyn-qa-message strong {
        color: inherit;
    }

    [data-bs-theme="dark"] span {
        color: #e5e7eb;
    }
</style>

